var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.performancesLoading)?_c('BlockHorizontalList',{attrs:{"title":"Fler föreställningar","type":"shows","shows":_vm.filteredPerformances}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }